export default __webpack_public_path__ + "img/arrowicon.b70f8f1a.svg";